module.exports = __webpack_public_path__ + "img/nc.71d8b56b.svg";